export function isIphone(): boolean {
    return !!navigator.userAgent.match(/iPhone/i);
}
